// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iZUW","left":"styles_left__2OTdU"};